export var IGetRetailerIdvStatusResponse;
(function (IGetRetailerIdvStatusResponse) {
    let IdvStatus;
    (function (IdvStatus) {
        /**
         * Unknown status.
         */
        IdvStatus["IDV_STATUS_UNKNOWN"] = "IDV_STATUS_UNKNOWN";
        /**
         * The retailer has never received any IDV request.
         */
        IdvStatus["NEVER_RECEIVED_IDV"] = "NEVER_RECEIVED_IDV";
        /**
         * There is an pending IDV request waiting for the retailer's response.
         */
        IdvStatus["HAS_PENDING_IDV_REQUEST"] = "HAS_PENDING_IDV_REQUEST";
        /**
         * The retailer has responded all IDV requests.
         */
        IdvStatus["IDV_REQUEST_RESPONDED"] = "IDV_REQUEST_RESPONDED";
    })(IdvStatus = IGetRetailerIdvStatusResponse.IdvStatus || (IGetRetailerIdvStatusResponse.IdvStatus = {}));
    /**
     * Return an instance of IGetRetailerIdvStatusResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IGetRetailerIdvStatusResponse.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IGetRetailerIdvStatusResponse || (IGetRetailerIdvStatusResponse = {}));
